import { createQueryClient } from './queries';

export const queryClient = createQueryClient();
